<style lang="scss" scoped>
// active / hover 背景色
$menu-active-bg-color: #F8FAFF;

.menu-wrapper {
  width: 200px;
  overflow: hidden;
  background-color: #fff;
  border-right: 1px solid #E3E6F0;
  z-index: 1400;
  &.collapse {
    width: 56px;
  }
  .menu-header-wrapper {
    height: 54px;
    line-height: 54px;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    // background-color: #000;
  }
  .menu-collapse {
    width: 26px;
    height: 30px;
    display: inline-block;
    line-height: 30px;
    text-align: center;
    border-radius: 4px;
    cursor: pointer;
    &:hover {
      background-color: #F5F6F9;
    }
    i {
      font-size: 16px;
      color: #636E95;
    }
  }
  .logo-wrapper {
    width: 136px;
    height: 26px;
    line-height: 26px;
    overflow: hidden;
    // background-color: #fff;
    margin-right: 10px;
    a {
      display: block;
    }
    img {
      width: 136px;
    }
  }
  .layout-tab-menu {
      width: 200px;
  }
  /* 
  ** el-menu 覆盖
  */
  ::v-deep {
    .el-menu {
      border: none;
    }
    .layout-tab-menu-collapse {
      width: 56px;
    }
    .app-is-active {
      &>.el-submenu__title,
      .is-active>.el-submenu__title,
      .is-active.el-menu-item {
        background-color: $menu-active-bg-color;
      }
      .is-active>.el-submenu__title,
      .is-active.el-menu-item {
        color: currentColor;
        &:after {
          content: '';
          width: 3px;
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          background-color: currentColor;
        }
        i {
          color: currentColor;
        }
      }
      .layout-tab-submenu-item>.el-submenu__title {
        padding-left: 44px !important;
        position: relative;
      }
    }
    .el-submenu__title {
      color: #353F66;
      font-size: 14px;
      width: 100%;
      line-height: 44px;
      height: 44px;
      padding: 0 17px !important;
      display: flex;
      flex-direction: row;
      align-items: center;
      .secondary-menu-name {
        display: inline-block;
        max-width: 112px;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-left: 0;
      }
      .icon-wrap {
        display: inline-flex;
        margin-left: 0;
        line-height: 18px;
      }
      .menu-icon {
        font-size: 18px;
        width: 18px;
        height: 18px;
        color: #353F66;
      }
      span {
        margin-left: 8px;
      }
    }
    .mall-menu-item {
      font-size: 14px;
      line-height: 44px;
      height: 44px;
      span {
        color: #353F66;
      }
    }
    .el-submenu__icon-arrow {
      font-size: 14px;
      font-weight: 700;
    }
    .layout-tab-submenu-item {
      .el-submenu__title {
        padding-left: 44px !important;
      }
      .el-icon-arrow-down {
        font-size: 12px;
        transform: rotate(-90deg);
      }
    }
    .menu-scrollbar {
      height: calc(100% - 54px);
    }
    div.el-submenu__title:hover,
    li.el-menu-item:focus,
    li.el-menu-item:hover {
      background-color: $menu-active-bg-color;
    }
    // 收起状态
    .collapse {
      .el-submenu__title {
        padding: 0 !important;
        justify-content: center;
        background-color: transparent;
        &:hover {
          background-color: transparent;
          .icon-wrap {
            background-color: $menu-active-bg-color;
          }
        }
        span {
          margin-left: 0;
        }
      }
      &.app-is-active .icon-wrap {
        background-color: $menu-active-bg-color;
      }
      .icon-wrap {
        width: 42px;
        height: 30px;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        visibility: visible;
        i {
          width: auto;
          height: auto;
        }
      }
    }
  }
}
</style>

<style lang="scss">
// active / hover 背景色
$menu-active-bg-color: #F8FAFF;
.layout-tab-menu-item__popover {
  &.el-popper[x-placement^=right] {
    padding: 0;
    margin-left: 5px;
  }
  li {
    height: 36px;
    line-height: 36px;
    padding: 0 16px;
    font-size: 14px;
    cursor: pointer;
    &:hover,
    &.is-active {
      background-color: $menu-active-bg-color;
      span {
        color: currentColor !important;
      }
    }
    span {
      color: #242F57;
      display: block;
    }
  }
}

.el-menu--vertical {
  .el-menu--popup {
    padding: 0;
  }
  .layout-tab-submenu-item {
    .el-submenu__title:hover,
    li.el-menu-item:hover {
      background-color: $menu-active-bg-color;
      span {
        color: currentColor !important;
      }
    }
    .el-submenu__title,
    .el-menu-item {
      height: 36px;
      line-height: 36px;
      padding: 0 16px !important;
      font-size: 14px;
      span {
        color: #2E3656;
      }
    }
    .el-menu--popup-right-start {
      margin-right: 0;
    }
  }
}

</style>

<script>
import { mapGetters } from 'vuex'
import { TAB_LIST_SESSION_KEY } from './constans'

const ASIDE_MENU_COLLAPSE_KEY = `ASIDE_MENU_COLLAPSE_KEY_${window.fe.project ? window.fe.project.toLocaleUpperCase() : ''}` // 本地存储展开/收起标识key

const appItemDefaultIcon = '&#xe7fd;'

export default {
  props: {
    // 默认展开的菜单
    defaultOpeneds: {
      type: Array,
      default: () => []
    },
    template: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    menuList () {
      if (!this.applicationClassifyList?.length) return []
      // 过滤掉portal
      return this.applicationClassifyList.filter(item => !!item.id)
    },
    routerPath () {
      // 菜单所属code，非列表页定位菜单使用
      let menuCode = this.$route.query.menuCode || this.$route.params.objectApiName || this.$route.meta.menuCode || this.$route.meta.authCode
      let path = menuCode ?? this.$route.path
      let arr = path.split('')
      // 适配路由末尾带/而无法展开默认
      return arr[arr.length - 1] === '/' ? arr.slice(0, arr.length - 1).join('') : path
    },
    // 当前路由获取场景id
    applicationClassifyId () {
      if (!this.allMenu[this.routerPath]) return ''
      const menuKey = Object.keys(this.allMenu).find(item => item.indexOf(this.routerPath) > -1)
      const { applicationClassifyId } = this.allMenu[menuKey]
      return applicationClassifyId
    },
    // 当前路由获取菜单apiName
    menuApiName () {
      if (!this.allMenu[this.routerPath]) return {}
      const { parentApiName } = this.allMenu[this.routerPath]
      return parentApiName
    },
    currentDefaultOpeneds () {
      if (this.defaultOpeneds?.length) return this.defaultOpeneds
      const appItem = this.applicationClassifyList.find(item => item.id === this.applicationClassifyId)
      return appItem ? [appItem.name] : []
    },
    ...mapGetters(['applicationClassifyList', 'allMenu'])
  },
  data () {
    return {
      collapse: false
    }
  },
  created () {
    this.collapse = sessionStorage.getItem(ASIDE_MENU_COLLAPSE_KEY) === 'true'
  },
  mouted () {
    this.$refs['menuScrollbar'] && this.$refs['menuScrollbar'].update()
    this.windowResizeHandle = debounce(() => {
      // 更新滚动条高度
      this.$refs['menuScrollbar'] && this.$refs['menuScrollbar'].update()
      // 更新滚动条位置
      // this.initScrollLocation()
    }, 300)
  },
  methods: {
    // menu展开收起标识
    collapseChangeHandle () {
      this.collapse = !this.collapse
      sessionStorage.setItem(ASIDE_MENU_COLLAPSE_KEY, `${this.collapse}`)
    },
    // 是否拓展坞
    isTailor (path) {
      return path.includes('tailor')
    },
    // 拓展坞跳转
    tailorMenuItemUrl (url) {
      const { project, baseUrl } = window.fe
      const tailorRouterMap = {
        purchaser: {
          routerKey: 'tailor',
          replaceKey: '/tailor_router'
        },
        supplier: {
          routerKey: 'tailor_supplier',
          replaceKey: '/tailor_supplier'
        }
      }
      if (!project || !baseUrl) return ''
      // 供应商跳转路径有差异
      return `${baseUrl}/${tailorRouterMap[project].routerKey}/#${url.replace(tailorRouterMap[project].replaceKey, '')}`
    },
    // 菜单路由
    menuItemRouter (url) {
      if (!url) return false
      const menuList = JSON.parse(sessionStorage.getItem(TAB_LIST_SESSION_KEY))
      const tab = menuList.find(item => {
        return item.menuCode === url
      })
      // 路由地址已创建页签，切换到对应页签的路由地址
      if (tab) {
        this.$emit('switchTab', tab)
        return false
      }

      this.isTailor(url)
        ? window.location.href = this.tailorMenuItemUrl(url)
        : this.$router.push(url)
    },
    /* 
    ** 自定义菜单
    ** 导航栏展开时三级菜单浮选展示
    */
    expandSubmenuItem (menuItem) {

      const defaultMenuItem = () => {
        const { applicationName, saasMenuModels, apiName } = menuItem
        return (
          <el-popover
            trigger='hover'
            placement='right-start'
            popper-class='layout-tab-menu-item__popover'
            visible-arrow={false}
          >
            <el-submenu 
              slot='reference'
              index={applicationName}
              class={
                ['layout-tab-submenu-item font-color-primary', {'is-active': this.menuApiName === apiName}]
              }
            >  {/* 菜单*/}
              <template slot='title'>
                <span class='secondary-menu-name' title={applicationName}>{applicationName}</span>
              </template>
            </el-submenu>
            <ul>
              {saasMenuModels.map(item => {
                return <li 
                  on-click={() => this.menuItemRouter(item.url)}
                  class={
                    ['font-color-primary', {'is-active': this.routerPath === item.url}]
                  }
                >
                  <span>{item.name}</span>
                </li>
              })}
            </ul>
          </el-popover>
        )
      }
      return menuItem?.saasMenuModels?.length ? defaultMenuItem() : this.mallMenuItem(menuItem)
    },
    /* 
    ** 标准菜单
    ** 导航栏收起
    */
    collapseSubmenuItem (menuItem) {
      const { apiName, applicationName, saasMenuModels } = menuItem
      const defaultMenuItem = () => (
        <el-submenu
          index={applicationName}
          class='layout-tab-submenu-item font-color-primary'
          show-timeout={200}
          hide-timeout={200}
          popper-class='layout-tab-submenu-item__popover'
        >  {/* 菜单*/}
          <template slot='title'>{applicationName}</template>
          {saasMenuModels.map(item => {
            return <el-menu-item
              class={
                ['font-color-primary', {'is-active': this.routerPath === item.url}]
              }
              index={item.url}
              on-click={() => this.menuItemRouter(item.url)}
            >
              <span>{item.name}</span>
            </el-menu-item>
          })}
        </el-submenu>
      )
      return menuItem?.saasMenuModels?.length ? defaultMenuItem() : this.mallMenuItem(menuItem)
    },
    // 商城端二级菜单
    mallMenuItem (menuItem) {
      const { applicationName, url } = menuItem
      return (
        <el-menu-item
          class={
            ['font-color-primary', 'mall-menu-item', {'is-active': this.routerPath === url}]
          }
          on-click={() => this.menuItemRouter(url)}
        >
          <span class={{'font-color-primary': this.routerPath === url}}>{applicationName}</span>
        </el-menu-item>
      )
    }
  },
  render () {
    const imgHost = window.Vue.filter('imgHost')
    return (
      <div 
        class={
          ['menu-wrapper', {'collapse': this.collapse}]
        }
      >
        <div class='menu-header-wrapper'>
          { 
            !this.collapse && <div class='logo-wrapper'>
              {
                this.template.data && (this.template.data[this.template.keys['linkKey']]
                  ? <a href={this.template.data[this.template.keys['linkKey']]} target="_blank">
                      <img src={imgHost(this.template.data[this.template.keys['logoKey']])} alt=''/>
                    </a>
                  : <img src={imgHost(this.template.data[this.template.keys['logoKey']])} alt=''/>)
              }
            </div> 
          }
          <el-tooltip 
            placement='right'
            content={`${this.collapse ? '展开' : '收起'}导航栏`}>
            <span class='menu-collapse'>
              <i
                class='iconfont'
                onClick={this.collapseChangeHandle}
                domPropsInnerHTML={this.collapse ? '&#xe75c;' : '&#xe75d;'}
              />
            </span>
          </el-tooltip>
        </div>
        <el-scrollbar ref='menuScrollbar' class='menu-scrollbar'>
          <el-menu
            collapse={this.collapse}
            collapse-transition={false}
            class={['layout-tab-menu', {'layout-tab-menu-collapse': this.collapse}]}
            default-openeds={this.currentDefaultOpeneds}
          >
            {this.menuList.map(appItem => {
              return (
                <el-submenu 
                  index={appItem.name}
                  class={
                    [{'collapse': this.collapse}, {'app-is-active': appItem.id === this.applicationClassifyId}]
                  }
                > {/* 场景 */}
                  <template slot='title'>
                    <span class='icon-wrap'>
                      <i class='iconfont menu-icon' domPropsInnerHTML={appItem.iconUrl || appItemDefaultIcon}></i>
                    </span>
                    {!this.collapse && <span>{appItem.name}</span>}
                  </template>
                  {appItem['appMenuList'].map(menuItem => {
                    return this.collapse ? this.collapseSubmenuItem(menuItem) : this.expandSubmenuItem(menuItem)
                  })}
                </el-submenu>
              )
            })}
          </el-menu>
        </el-scrollbar>
      </div>
    )
  }
}
</script>